import React, { useEffect, useState } from "react";
import { HardDrive } from "lucide-react";
import api from "../../api";

const mb = (b) => `${(Number(b || 0) / 1048576).toFixed(1)} MB`;
const kb = (b) => `${Math.round(Number(b || 0) / 1024)} KB`;

// A number instead of a guess: when this approaches ~20GB it's time to look at R2.
export const AdminStorage = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/storage").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const monthly = d.last30dBytes || 0;
  const monthsTo20Gb = monthly > 0 ? Math.floor((20 * 1073741824 - d.totalBytes) / monthly) : null;

  return (
    <div className="bg-card border border-border rounded-2xl p-5" data-testid="admin-storage">
      <h2 className="font-bold text-foreground flex items-center gap-2"><HardDrive size={18} className="text-[#16a34a]" /> Image storage</h2>
      <p className="text-xs text-muted-foreground mt-0.5 mb-4">
        Uploads live in object storage, not on the pod disk.
        {monthsTo20Gb != null && monthsTo20Gb < 600 ? ` At the last 30 days' pace you're about ${monthsTo20Gb} months from 20 GB.` : ""}
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="rounded-xl bg-secondary/50 p-3" data-testid="storage-total">
          <p className="text-xl font-extrabold text-foreground">{mb(d.totalBytes)}</p>
          <p className="text-xs text-muted-foreground">in use · {d.files} files</p>
        </div>
        <div className="rounded-xl bg-secondary/50 p-3" data-testid="storage-avg">
          <p className="text-xl font-extrabold text-foreground">{kb(d.avgBytes)}</p>
          <p className="text-xs text-muted-foreground">average file</p>
        </div>
        <div className="rounded-xl bg-secondary/50 p-3" data-testid="storage-30d">
          <p className="text-xl font-extrabold text-foreground">{mb(d.last30dBytes)}</p>
          <p className="text-xs text-muted-foreground">last 30 days · {d.last30dFiles} files</p>
        </div>
        <div className="rounded-xl bg-secondary/50 p-3" data-testid="storage-saved">
          <p className="text-xl font-extrabold text-[#16a34a]">{mb(d.savedBytes)}</p>
          <p className="text-xs text-muted-foreground">saved by WebP re-encoding</p>
        </div>
      </div>
      <p className="text-xs text-muted-foreground mt-3">
        {Object.entries(d.types || {}).map(([t, n]) => `${n} ${t}`).join(" · ")}
        {d.privateFiles ? ` · ${d.privateFiles} private documents` : ""}
      </p>
    </div>
  );
};
